import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseZoningPlanValidationSchema = Yup.object({
  countyCityMunicipality: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
});
